import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef, useStyleConfig, omitThemingProps, useFormControlContext, chakra } from '@chakra-ui/react';
import { cx } from '@chakra-ui/utils';
import * as React from 'react';
import { useEffect } from 'react';
import { warn } from '../../utils/logger.js';
import { RequiredIndicator } from './RequiredIndicator.js';
var _excluded = ["className", "children", "isMandatory", "requiredIndicator", "isRequired"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

/**
 * Used to enhance the usability of form controls.
 *
 * It is used to inform users as to what information
 * is requested for a form field.
 *
 * ♿️ Accessibility: Every form field should have a form label.
 */
var Label = forwardRef(function (passedProps, ref) {
  var _field$getLabelProps;
  var styles = useStyleConfig('Label', passedProps);
  var props = omitThemingProps(passedProps);
  props.className;
  var children = props.children,
    isMandatory = props.isMandatory,
    _props$requiredIndica = props.requiredIndicator,
    requiredIndicator = _props$requiredIndica === void 0 ? /*#__PURE__*/React.createElement(RequiredIndicator, null) : _props$requiredIndica,
    _props$isRequired = props.isRequired,
    isRequired = _props$isRequired === void 0 ? isMandatory : _props$isRequired,
    rest = _objectWithoutProperties(props, _excluded);
  useEffect(function () {
    warn('`isMandatory` is deprecated and will be removed in the future. Use `isRequired`.', 'Label', isMandatory !== undefined);
  }, [isMandatory]);
  var field = useFormControlContext();
  var ownProps = (_field$getLabelProps = field === null || field === void 0 ? void 0 : field.getLabelProps(rest, ref)) !== null && _field$getLabelProps !== void 0 ? _field$getLabelProps : _objectSpread({
    ref: ref
  }, rest);
  return /*#__PURE__*/React.createElement(chakra.label, _extends({}, ownProps, {
    className: cx('chakra-label', props.className),
    __css: _objectSpread({
      display: 'block',
      textAlign: 'start'
    }, styles)
  }), children, isRequired || field !== null && field !== void 0 && field.isRequired ? requiredIndicator : null);
});
export { Label };